import { FC, useState, useEffect } from 'react';
import { Box } from 'ui/Box';
import { Typography } from 'ui/Typography';
import { InputLabel } from 'modules/RegisterModule/components/InputLabel';
import { Member, AddedMember } from 'types/api';

export interface ModalMemberItemProps {
  selectOptions: { value: string; label: string }[];
  index: number;
  errors?: Member;
  addedMember?: AddedMember;
  resetForm?: boolean;
}
export const ModalMemberItem: FC<ModalMemberItemProps> = ({
  addedMember,
  selectOptions,
  index,
  errors,
  resetForm = false,
}) => {
  const [selectedValue, setSelectedValue] = useState(addedMember?.role || '');
  const [email, setEmail] = useState(addedMember?.email || '');
  const [name, setName] = useState(addedMember?.full_name || '');
  const [position, setPosition] = useState(addedMember?.position || '');

  useEffect(() => {
    if (resetForm) {
      setEmail('');
      setName('');
      setPosition('');
      setSelectedValue('');
    }
  }, [resetForm, addedMember]);

  const onSelect = (value: string | string[]) => {
    setSelectedValue(value as string);
  };

  return (
    <Box className="flex w-full flex-col gap-2">
      <Typography
        variant="h5"
        className="mb-3 rounded bg-light-gray px-3 py-2 text-black"
      >
        #{index + 1}
      </Typography>
      <Box className="flex flex-col gap-6 md:gap-2">
        <InputLabel
          value={email}
          onChange={(email) => setEmail(email)}
          label="Email"
          placeholder="Email"
          name={'email'}
          error={errors?.email}
        />
        <InputLabel
          onChange={(name) => setName(name)}
          value={name}
          label="Full Name"
          placeholder="Full name"
          name={'name'}
          error={errors?.name}
        />
        <InputLabel
          label="Role"
          placeholder="Choose from the list"
          name="role"
          variant="select"
          selectOptions={selectOptions}
          onSelect={(value) => onSelect(value)}
          selectedValue={selectedValue}
          value={selectedValue}
          error={errors?.role}
        />
        <InputLabel
          onChange={(position) => setPosition(position)}
          value={position}
          label="Position"
          placeholder="Position"
          name="position"
          error={errors?.position}
        />
      </Box>
    </Box>
  );
};
